import { useDispatch } from 'react-redux';
import { addToCart } from '@client/cart/redux/addToCart/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useAddToCartAction = (): typeof addToCart => {
  const dispatch = useDispatch();

  return bindActionCreators(addToCart, dispatch);
};
